import { gql } from '@apollo/client';
import { activityAnswerFragment } from '@ts-core/modules/activities/graphql/fragments';

export const professorActivityFragment = gql`
  fragment ProfessorActivity on Activity {
    id
    name
    statement
    deadline
    expired
    enabled
    answerFileSizeLimit

    createdBy
  }
`;

export const professorActivityAnswerFragment = gql`
  fragment ProfessorActivityAnswer on ActivityAnswer {
    ...ActivityAnswer
    student {
      id
      email
      name
      group
    }
  }
  ${activityAnswerFragment}
`;
